import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Section } from '@scope/scope-one-ui/core';
import { PageData } from '../../types/climateStressTest';
import { OutputLoss } from './OutputLoss';
import { CarbonIntensity } from './CarbonIntensity';
import { CarbonTaxEvolution } from './CarbonTaxEvolution';

const chips = [
  'OUTPUT LOSS FROM TRANSITION RISK',
  'CARBON INTENSITY',
  'EVOLUTION OF THE CARBON TAX',
];

export const TransitionRisk: FC<PageData> = (pageData) => {
  const { t } = useTranslation();

  return (
    <Section header={t('Transition Risk')} chips={chips}>
      <Box display="flex" flexDirection="column" gridGap={4}>
        <OutputLoss {...pageData} />
        <Box display="flex" gridGap={4} mb={0.5}>
          <Box display="flex" flexDirection="column" flex={1}>
            <CarbonIntensity {...pageData} />
          </Box>
          <Box display="flex" flexDirection="column" flex={1}>
            <CarbonTaxEvolution {...pageData} />
          </Box>
        </Box>
      </Box>
    </Section>
  );
};
